var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4674)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1_4674)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79013 18.1498C2.875 16.8902 2.875 15.0935 2.875 11.5C2.875 7.90651 2.875 6.10976 3.79013 4.8502C4.08567 4.44341 4.44341 4.08567 4.8502 3.79013C6.10976 2.875 7.90651 2.875 11.5 2.875C15.0935 2.875 16.8902 2.875 18.1498 3.79013C18.5566 4.08567 18.9143 4.44341 19.2099 4.8502C20.125 6.10976 20.125 7.90651 20.125 11.5C20.125 15.0935 20.125 16.8902 19.2099 18.1498C18.9143 18.5566 18.5566 18.9143 18.1498 19.2099C16.8902 20.125 15.0935 20.125 11.5 20.125C7.90651 20.125 6.10976 20.125 4.8502 19.2099C4.44341 18.9143 4.08567 18.5566 3.79013 18.1498Z",
    fill: "#CEEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79013 18.1498C2.875 16.8902 2.875 15.0935 2.875 11.5C2.875 7.90651 2.875 6.10976 3.79013 4.8502C4.08567 4.44341 4.44341 4.08567 4.8502 3.79013C6.10976 2.875 7.90651 2.875 11.5 2.875C15.0935 2.875 16.8902 2.875 18.1498 3.79013C18.5566 4.08567 18.9143 4.44341 19.2099 4.8502C20.125 6.10976 20.125 7.90651 20.125 11.5C20.125 15.0935 20.125 16.8902 19.2099 18.1498C18.9143 18.5566 18.5566 18.9143 18.1498 19.2099C16.8902 20.125 15.0935 20.125 11.5 20.125C7.90651 20.125 6.10976 20.125 4.8502 19.2099C4.44341 18.9143 4.08567 18.5566 3.79013 18.1498Z",
    stroke: "url(#paint0_linear_1_4674)",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_4674)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8022 12.9107C17.0816 13.1926 17.0796 13.6477 16.7976 13.9272C16.5157 14.2066 16.0606 14.2046 15.7812 13.9226L14.1067 12.2331C13.4271 11.5474 12.9594 11.0771 12.5631 10.7588C12.1781 10.4497 11.9309 10.3436 11.7094 10.3154C11.5704 10.2977 11.4297 10.2977 11.2906 10.3154C11.0692 10.3436 10.8219 10.4497 10.4369 10.7588C10.0406 11.0771 9.57293 11.5474 8.89334 12.2331L7.21883 13.9226C6.9394 14.2046 6.48431 14.2066 6.20238 13.9272C5.92044 13.6477 5.91841 13.1926 6.19784 12.9107L7.90251 11.1908C8.54453 10.543 9.06928 10.0135 9.53682 9.63801C10.023 9.24756 10.5165 8.96492 11.1088 8.88941C11.3686 8.85631 11.6314 8.85631 11.8912 8.88941C12.4835 8.96492 12.977 9.24756 13.4632 9.63801C13.9307 10.0135 14.4555 10.5429 15.0975 11.1907L16.8022 12.9107Z",
    fill: "url(#paint1_linear_1_4674)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1_4674",
    x: -21.625,
    y: -21.625,
    width: 66.25,
    height: 66.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_4674"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_4674",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_4674",
    x: 2.98959,
    y: 5.86459,
    width: 27.0208,
    height: 21.2708,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4674"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4674",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4674",
    x1: 2.875,
    y1: 20.125,
    x2: 20.1337,
    y2: 2.88375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_4674",
    x1: 11.5928,
    y1: 7.74167,
    x2: 17.3276,
    y2: 19.4957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpSquare);
export default __webpack_public_path__ + "static/media/up-square.d22e73edfe2b08fb0463c46cc4e6132d.svg";
export { ForwardRef as ReactComponent };